import React from "react";
import ReactDOM from "react-dom";
import { observer } from "mobx-react-lite";
import { PolotnoContainer, SidePanelWrap, WorkspaceWrap } from 'polotno';
import { Workspace } from "polotno/canvas/workspace";
import {
  SidePanel,
  SectionTab,
  LayersSection
} from "polotno/side-panel";
import { isGradient, parseColor } from "polotno/utils/gradient";
import { Toolbar } from "polotno/toolbar/toolbar";
import { ZoomButtons } from "polotno/toolbar/zoom-buttons";
import { createStore } from "polotno/model/store";
import { getImageSize } from "polotno/utils/image";
import { Tabs, Tab } from "@blueprintjs/core";
import '@blueprintjs/core/lib/css/blueprint.css';
import {
  Button,
  Navbar,
  Alignment,
} from '@blueprintjs/core';
import '@blueprintjs/core/lib/css/blueprint.css';
import styled from 'polotno/utils/styled';
import { ImagesGrid } from "polotno/side-panel/images-grid";
import { useState } from 'react';
import MdcQualityHigh from '@meronex/icons/mdc/MdcQualityHigh';
import { Adsense } from '@ctrl/react-adsense';
import { setColorsPresetFunc } from 'polotno/config';
import BiShieldQuarter from '@meronex/icons/bi/BiShieldQuarter';
import FaCrown from '@meronex/icons/fa/FaCrown';
import MdColorPalette from '@meronex/icons/ios/MdColorPalette';
import BiText from '@meronex/icons/bi/BiText';
import FaFileImport from '@meronex/icons/fa/FaFileImport';
import GiLion from '@meronex/icons/gi/GiLion';
import { Icon } from "@blueprintjs/core";
import TutorialModal from './components/TutorialModal';
import './App.css';
import FaMagic from '@meronex/icons/fa/FaMagic';


const store = createStore({
  // https://polotno.dev/cabinet
  key: "cWIIWTmkMgSoPVuDcMiK"
});



const DEFAULT_COLORS = ['#F7C702', '#F2F2F2', '#013B90', '#BB212C', '#742974', '#1B1B1B', '#1D5E23', '#CE956C', '#e4ba99', '#793D11', '#B5B5B5', '#47464B', '#F0701A'];

function sameColors(color1, color2) {
  return color1 === color2;
}

export const getUsedColors = (store) => {
  const colors = [];
  store.pages.forEach((page) => {
    page.children.forEach((element) => {
      if (element.type === 'text') {
        colors.push(element.fill);
      }
      if (element.type === 'svg') {
        colors.push(...Array.from(element.colorsReplace.values()));
      }
    });
  });

  const solidColors = [];
  colors.forEach((color) => {
    if (isGradient(color)) {
      const { stops } = parseColor(color);
      solidColors.push(...stops.map((stop) => stop.color));
    } else {
      solidColors.push(color);
    }
  });

  return [...new Set(solidColors.reverse())];
};

let getColorsPreset = (store) => {
  const colors = getUsedColors(store).slice(0, 40);
  const colorsWithoutDefault = colors.filter((color) => {
    const isDefault = DEFAULT_COLORS.find((c) => sameColors(c, color));
    return !isDefault;
  });

  const preset = colorsWithoutDefault.concat(
    DEFAULT_COLORS.slice(0, 40 - colorsWithoutDefault.length)
  );

  return preset;

};

setColorsPresetFunc((store) => {
  return getColorsPreset(store);
});

const AVAILABLE_SIZES = [
  { "format": "Square", "width": 1080, "height": 1080 },
  { "format": "Instagram Story / TikTok", "width": 1080, "height": 1920 },
  { "format": "Facebook Image", "width": 1200, "height": 630 },
  { "format": "Twitter Image", "width": 900, "height": 450 },
  { "format": "Pinterest", "width": 1000, "height": 1500 },
  { "format": "Tumblr", "width": 750, "height": 500 },
  { "format": "YouTube Thumbnail ", "width": 1280, "height": 720 },
  { "format": "YouTube Banner", "width": 2560, "height": 1440 }
];


const NavbarContainer = styled('div')`
  @media screen and (max-width: 500px) {
    overflow-x: auto;
    overflow-y: hidden;
    max-width: 100vw;
  }
`;

const NavInner = styled('div')`
  @media screen and (max-width: 500px) {
    display: flex;
  }
`;


store.addPage(
  { background: "white" }
);

//console.log(store.activePage.children);

store.activePage.addElement({
  type: "svg",
  src: "/wp-content/coamakerbasic/coageneral/coamakerlogo.svg",
  height: 100,
  width: 201,
  x: 25,
  y: 960,
  name: "CoaMaker Logo",
  locked: true,
  selectable: false,
  alwaysOnTop: true,
  id: "logo"
});

store.activePage.addElement({
  type: "svg",
  src: "/wp-content/coamakerbasic/img/345_Shield_undivided.svg",
  height: 1000,
  width: 816,
  x: 130,
  y: 33,
  name: "Escutcheon",
  keepRatio: false
});


store.activePage.addElement({
  type: "svg",
  src: "/wp-content/coamakerbasic/img/563_dragonrampant.svg",
  height: 750,
  width: 630,
  x: 220,
  y: 130,
  name: "Dragon",
  keepRatio: false
});

function CoaAdsense() {
  return <div className="coa-top-ad"><Adsense
    client="ca-pub-7706095824493443"
    data-ad-format="fluid"
    data-ad-layout-key="-fb+5w+4e-db+86"
    data-ad-client="ca-pub-7706095824493443"
    data-ad-slot="4392451863"
  /></div>
}



const AnimalSection = {
  name: 'animals',
  Tab: (props) => (
    <SectionTab name="Charges" {...props}>
      <GiLion />
    </SectionTab>
  ),
  // we need observer to update component automatically on any store changes
  Panel: observer(({ store }) => {
    const [images, setImages] = React.useState([]);

    async function loadImages() {
      const time = parseInt((new Date()).getTime() / 100000);
      const animalUrl = "/wp-content/coamakerbasic/coa/0_coam.json?=ver";
      const animalFetch = animalUrl + time;
      fetch(animalFetch)
        .then(function (resp) {
          return resp.json();
        })
        .then(function (data) {
          setImages(data);
        });
      //setImages(data.url);
      await new Promise((resolve) => setTimeout(resolve, 3000));
    }

    React.useEffect(() => {
      loadImages();
    }, []);

    const [coaSearchTerm, setSearchTerm] = useState('');

    var aniImages = []
    for (var i = 0; i < images.length; i++) {
      let image = images[i];
      if (coaSearchTerm === "") {
        if ((image["pro"] === false) && (image["sec"] === "ani")) {
          aniImages.push(images[i]);
        }
      }
      else if (coaSearchTerm !== "") {
        if (
          (image["pro"] === false) &&
          (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
            && ((image["sec"] === "ani") || (image["sec"] === "pla") || (image["sec"] === "hum") || (image["sec"] === "ina"))
          )) {
          aniImages.push(images[i]);
        }
      }
    }

    var inaImages = []
    for (var j = 0; j < images.length; j++) {
      let image = images[j];
      if (coaSearchTerm === "") {
        if ((image["pro"] === false) && (image["sec"] === "ina")) {
          inaImages.push(images[j]);
        }
      }
      else if (coaSearchTerm !== "") {
        if (
          (image["pro"] === false) &&
          (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
            && ((image["sec"] === "ani") || (image["sec"] === "pla") || (image["sec"] === "hum") || (image["sec"] === "ina"))
          )) {
          inaImages.push(images[j]);
        }
      }
    }

    var humImages = []
    for (var k = 0; k < images.length; k++) {
      let image = images[k];
      if (coaSearchTerm === "") {
        if ((image["pro"] === false) && (image["sec"] === "hum")) {
          humImages.push(images[k]);
        }
      }
      else if (coaSearchTerm !== "") {
        if (
          (image["pro"] === false) &&
          (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
            && ((image["sec"] === "ani") || (image["sec"] === "pla") || (image["sec"] === "hum") || (image["sec"] === "ina"))
          )) {
          humImages.push(images[k]);
        }
      }
    }

    var plaImages = []
    for (var m = 0; m < images.length; m++) {
      let image = images[m];
      if (coaSearchTerm === "") {
        if ((image["pro"] === false) && (image["sec"] === "pla")) {
          plaImages.push(images[m]);
        }
      }
      else if (coaSearchTerm !== "") {
        if (
          (image["pro"] === false) &&
          (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
            && ((image["sec"] === "ani") || (image["sec"] === "pla") || (image["sec"] === "hum") || (image["sec"] === "ina"))
          )) {
          plaImages.push(images[m]);
        }
      }
    }

    var aniPreview = []
    for (var i = 0; i < images.length; i++) {
      let image = images[i];
      if (coaSearchTerm === "") {
        if ((image["pro"] === true) && (image["sec"] === "ani")) {
          aniPreview.push(images[i]);
        }
      }
      else if (coaSearchTerm !== "") {
        if (
          (image["pro"] === true) &&
          (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
            && ((image["sec"] === "ani") || (image["sec"] === "pla") || (image["sec"] === "hum") || (image["sec"] === "ina"))
          )) {
          aniPreview.push(images[i]);
        }
      }
    }

    var inaPreview = []
    for (var j = 0; j < images.length; j++) {
      let image = images[j];
      if (coaSearchTerm === "") {
        if ((image["pro"] === true) && (image["sec"] === "ina")) {
          inaPreview.push(images[j]);
        }
      }
      else if (coaSearchTerm !== "") {
        if (
          (image["pro"] === true) &&
          (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
            && ((image["sec"] === "ani") || (image["sec"] === "pla") || (image["sec"] === "hum") || (image["sec"] === "ina"))
          )) {
          inaPreview.push(images[j]);
        }
      }
    }

    var humPreview = []
    for (var k = 0; k < images.length; k++) {
      let image = images[k];
      if (coaSearchTerm === "") {
        if ((image["pro"] === true) && (image["sec"] === "hum")) {
          humPreview.push(images[k]);
        }
      }
      else if (coaSearchTerm !== "") {
        if (
          (image["pro"] === true) &&
          (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
            && ((image["sec"] === "ani") || (image["sec"] === "pla") || (image["sec"] === "hum") || (image["sec"] === "ina"))
          )) {
          humPreview.push(images[k]);
        }
      }
    }

    var plaPreview = []
    for (var m = 0; m < images.length; m++) {
      let image = images[m];
      if (coaSearchTerm === "") {
        if ((image["pro"] === true) && (image["sec"] === "pla")) {
          plaPreview.push(images[m]);
        }
      }
      else if (coaSearchTerm !== "") {
        if (
          (image["pro"] === true) &&
          (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
            && ((image["sec"] === "ani") || (image["sec"] === "pla") || (image["sec"] === "hum") || (image["sec"] === "ina"))
          )) {
          plaPreview.push(images[m]);
        }
      }
    }

    var previewImages = []
    for (var i = 0; i < images.length; i++) {
      let image = images[i];
      if (image["pro"] === true) {
        previewImages.push(images[i]);
      }
    }

    var len = previewImages.length

    function CoaElementsPreview(props) {
      return <div className="coam-info-container">
        <hr />
        <div className="coam-info-head">{props.head || "More Elements with PRO"}</div>
        <div className="coam-info-text">{props.text || len + " extra elements. More coming every month."}</div>
        <div className="coam-info-button-div"><a href="/subscription-plan/" target="_blank"><span className="coam-info-button">Unlock all elements</span></a></div>
      </div>
    }

    return (
      <div className="coaChargesContainer" style={{ height: "73vh", display: "flex", flexDirection: "column", overflowY: "auto" }}>
        <CoaAdsense></CoaAdsense>
        <div><input className="coaSearchInput" type="text" placeholder="Search Charges" onChange={event => { setSearchTerm(event.target.value) }} /></div>
        <Tabs
          animate={true}
          key={"vertical"}
          vertical={false}
        >
          <Tab id="fan" title="Animals" panel={
            <div style={{ height: "70vh" }}>
              <div>
                <ImagesGrid
                  images={aniImages}
                  getPreview={(image) => {
                    const modifiedUrl = `/wp-content/coamakerbasic/prev/${image.preview}`;
                    return modifiedUrl;
                  }}
                  onSelect={async (image, pos) => {
                    let url = image.url;
                    if (url.search(".svg") === -1) {
                      url = `/wp-content/coamakerbasic/img/${url}.svg`
                    }
                    image.url = url;
                    let { width, height } = await getImageSize(image.url);
                    width = width / 1.5;
                    height = height / 1.5;
                    store.activePage.addElement({
                      type: "svg",
                      src: image.url,
                      width,
                      height,
                      x: (pos?.x - width / 1.5) || (store.width / 2) - (width / 2),
                      y: (pos?.y - height / 1.5) || (store.height / 2) - (height / 2),
                      name: image.name,
                      keepRatio: false
                    });
                  }}
                  rowsNumber={4}
                  isLoading={false}
                  loadMore={false}
                  getCredit={(image) => image.name}
                />
              </div>
              <div className={"coa-pro-preview"}>
                <CoaElementsPreview></CoaElementsPreview>
                <ImagesGrid
                  images={aniPreview}
                  getPreview={(image) => {
                    const modifiedUrl = `/wp-content/coamakerbasic/prev/${image.preview}`;
                    return modifiedUrl;
                  }}
                  onSelect={async (image, pos) => {
                  }}
                  rowsNumber={4}
                  isLoading={!images.length}
                  loadMore={false}
                  getCredit={(image) => image.name}
                />
              </div>
            </div>
          } />
          <Tab id="fpl" title="Plants" panel={
            <div><ImagesGrid
              images={plaImages}
              getPreview={(image) => {
                const modifiedUrl = `/wp-content/coamakerbasic/prev/${image.preview}`;
                return modifiedUrl;
              }}
              onSelect={async (image, pos) => {
                let url = image.url;
                if (url.search(".svg") === -1) {
                  url = `/wp-content/coamakerbasic/img/${url}.svg`
                }
                image.url = url;
                let { width, height } = await getImageSize(image.url);
                width = width / 1.5;
                height = height / 1.5;
                store.activePage.addElement({
                  type: "svg",
                  src: image.url,
                  width,
                  height,
                  x: (pos?.x - width / 1.5) || (store.width / 2) - (width / 2),
                  y: (pos?.y - height / 1.5) || (store.height / 2) - (height / 2),
                  name: image.name,
                  keepRatio: false
                });
              }}
              rowsNumber={4}
              isLoading={false}
              loadMore={false}
              getCredit={(image) => image.name}
            />
              <div className={"coa-pro-preview"}>
                <CoaElementsPreview></CoaElementsPreview>
                <ImagesGrid
                  images={plaPreview}
                  getPreview={(image) => {
                    const modifiedUrl = `/wp-content/coamakerbasic/prev/${image.preview}`;
                    return modifiedUrl;
                  }}
                  onSelect={async (image, pos) => {
                  }}
                  rowsNumber={4}
                  isLoading={!images.length}
                  loadMore={false}
                  getCredit={(image) => image.name}
                />
              </div>
            </div>
          } />
          <Tab id="fob" title="Objects" panel={
            <div><ImagesGrid
              images={inaImages}
              getPreview={(image) => {
                const modifiedUrl = `/wp-content/coamakerbasic/prev/${image.preview}`;
                return modifiedUrl;
              }}
              onSelect={async (image, pos) => {
                let url = image.url;
                if (url.search(".svg") === -1) {
                  url = `/wp-content/coamakerbasic/img/${url}.svg`
                }
                image.url = url;
                let { width, height } = await getImageSize(image.url);
                width = width / 1.5;
                height = height / 1.5;
                store.activePage.addElement({
                  type: "svg",
                  src: image.url,
                  width,
                  height,
                  x: (pos?.x - width / 1.5) || (store.width / 2) - (width / 2),
                  y: (pos?.y - height / 1.5) || (store.height / 2) - (height / 2),
                  name: image.name,
                  keepRatio: false
                });
              }}
              rowsNumber={4}
              isLoading={false}
              loadMore={false}
              getCredit={(image) => image.name}
            />
              <div className={"coa-pro-preview"}>
                <CoaElementsPreview></CoaElementsPreview>
                <ImagesGrid
                  images={inaPreview}
                  getPreview={(image) => {
                    const modifiedUrl = `/wp-content/coamakerbasic/prev/${image.preview}`;
                    return modifiedUrl;
                  }}
                  onSelect={async (image, pos) => {
                  }}
                  rowsNumber={4}
                  isLoading={!images.length}
                  loadMore={false}
                  getCredit={(image) => image.name}
                />
              </div>
            </div>
          } />
          <Tab id="fhu" title="Humans" panel={
            <div><ImagesGrid
              images={humImages}
              getPreview={(image) => {
                const modifiedUrl = `/wp-content/coamakerbasic/prev/${image.preview}`;
                return modifiedUrl;
              }}
              onSelect={async (image, pos) => {
                let url = image.url;
                if (url.search(".svg") === -1) {
                  url = `/wp-content/coamakerbasic/img/${url}.svg`
                }
                image.url = url;
                let { width, height } = await getImageSize(image.url);
                width = width / 1.5;
                height = height / 1.5;
                store.activePage.addElement({
                  type: "svg",
                  src: image.url,
                  width,
                  height,
                  x: (pos?.x - width / 1.5) || (store.width / 2) - (width / 2),
                  y: (pos?.y - height / 1.5) || (store.height / 2) - (height / 2),
                  name: image.name,
                  keepRatio: false
                });
              }}
              rowsNumber={4}
              isLoading={false}
              loadMore={false}
              getCredit={(image) => image.name}
            />
              <div className={"coa-pro-preview"}>
                <CoaElementsPreview></CoaElementsPreview>
                <ImagesGrid
                  images={humPreview}
                  getPreview={(image) => {
                    const modifiedUrl = `/wp-content/coamakerbasic/prev/${image.preview}`;
                    return modifiedUrl;
                  }}
                  onSelect={async (image, pos) => {
                  }}
                  rowsNumber={4}
                  isLoading={!images.length}
                  loadMore={false}
                  getCredit={(image) => image.name}
                />
              </div>
            </div>
          } />
        </Tabs>
      </div>

    );
  }),
};

const TopSection = {
  name: 'top',
  Tab: (props) => (
    <SectionTab name="Exterior" {...props}>
      <FaCrown />
    </SectionTab>
  ),
  // we need observer to update component automatically on any store changes
  Panel: observer(({ store }) => {
    const [images, setImages] = React.useState([]);

    async function loadImages() {
      const time = parseInt((new Date()).getTime() / 100000);
      const animalUrl = "/wp-content/coamakerbasic/coa/0_coam.json?=ver";
      const animalFetch = animalUrl + time;
      fetch(animalFetch)
        .then(function (resp) {
          return resp.json();
        })
        .then(function (data) {
          setImages(data);
        });
      //setImages(data.url);
      await new Promise((resolve) => setTimeout(resolve, 3000));
    }

    React.useEffect(() => {
      loadImages();
    }, []);

    const [coaSearchTerm, setSearchTerm] = useState('');

    var mtlImages = []
    for (var i = 0; i < images.length; i++) {
      let image = images[i];
      if (coaSearchTerm === "") {
        if ((image["pro"] === false) && (image["sec"] === "mtl")) {
          mtlImages.push(images[i]);
        }
      }
      else if (coaSearchTerm !== "") {
        if (
          (image["pro"] === false) &&
          (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
            && ((image["sec"] === "mtl") || (image["sec"] === "cor") || (image["sec"] === "sup") || (image["sec"] === "oth"))
          )) {
          mtlImages.push(images[i]);
        }
      }
    }

    var corImages = []
    for (var j = 0; j < images.length; j++) {
      let image = images[j];
      if (coaSearchTerm === "") {
        if ((image["pro"] === false) && (image["sec"] === "cor")) {
          corImages.push(images[j]);
        }
      }
      else if (coaSearchTerm !== "") {
        if (
          (image["pro"] === false) &&
          (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
            && ((image["sec"] === "mtl") || (image["sec"] === "cor") || (image["sec"] === "sup") || (image["sec"] === "oth"))
          )) {
          corImages.push(images[j]);
        }
      }
    }

    var supImages = []
    for (var k = 0; k < images.length; k++) {
      let image = images[k];
      if (coaSearchTerm === "") {
        if ((image["pro"] === false) && (image["sec"] === "sup")) {
          supImages.push(images[k]);
        }
      }
      else if (coaSearchTerm !== "") {
        if (
          (image["pro"] === false) &&
          (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
            && ((image["sec"] === "mtl") || (image["sec"] === "cor") || (image["sec"] === "sup") || (image["sec"] === "oth"))
          )) {
          supImages.push(images[k]);
        }
      }
    }

    var othImages = []
    for (var m = 0; m < images.length; m++) {
      let image = images[m];
      if (coaSearchTerm === "") {
        if ((image["pro"] === false) && (image["sec"] === "oth")) {
          othImages.push(images[m]);
        }
      }
      else if (coaSearchTerm !== "") {
        if (
          (image["pro"] === false) &&
          (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
            && ((image["sec"] === "mtl") || (image["sec"] === "cor") || (image["sec"] === "sup") || (image["sec"] === "oth"))
          )) {
          othImages.push(images[m]);
        }
      }
    }

    var mtlPreview = []
    for (var i = 0; i < images.length; i++) {
      let image = images[i];
      if (coaSearchTerm === "") {
        if ((image["pro"] === true) && (image["sec"] === "mtl")) {
          mtlPreview.push(images[i]);
        }
      }
      else if (coaSearchTerm !== "") {
        if (
          (image["pro"] === true) &&
          (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
            && ((image["sec"] === "mtl") || (image["sec"] === "cor") || (image["sec"] === "sup") || (image["sec"] === "oth"))
          )) {
          mtlPreview.push(images[i]);
        }
      }
    }

    var corPreview = []
    for (var j = 0; j < images.length; j++) {
      let image = images[j];
      if (coaSearchTerm === "") {
        if ((image["pro"] === true) && (image["sec"] === "cor")) {
          corPreview.push(images[j]);
        }
      }
      else if (coaSearchTerm !== "") {
        if (
          (image["pro"] === true) &&
          (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
            && ((image["sec"] === "mtl") || (image["sec"] === "cor") || (image["sec"] === "sup") || (image["sec"] === "oth"))
          )) {
          corPreview.push(images[j]);
        }
      }
    }

    var supPreview = []
    for (var k = 0; k < images.length; k++) {
      let image = images[k];
      if (coaSearchTerm === "") {
        if ((image["pro"] === true) && (image["sec"] === "sup")) {
          supPreview.push(images[k]);
        }
      }
      else if (coaSearchTerm !== "") {
        if (
          (image["pro"] === true) &&
          (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
            && ((image["sec"] === "mtl") || (image["sec"] === "cor") || (image["sec"] === "sup") || (image["sec"] === "oth"))
          )) {
          supPreview.push(images[k]);
        }
      }
    }

    var othPreview = []
    for (var m = 0; m < images.length; m++) {
      let image = images[m];
      if (coaSearchTerm === "") {
        if ((image["pro"] === true) && (image["sec"] === "oth")) {
          othPreview.push(images[m]);
        }
      }
      else if (coaSearchTerm !== "") {
        if (
          (image["pro"] === true) &&
          (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
            && ((image["sec"] === "mtl") || (image["sec"] === "cor") || (image["sec"] === "sup") || (image["sec"] === "oth"))
          )) {
          othPreview.push(images[m]);
        }
      }
    }

    var previewImages = []
    for (var i = 0; i < images.length; i++) {
      let image = images[i];
      if (image["pro"] === true) {
        previewImages.push(images[i]);
      }
    }

    var len = previewImages.length

    function CoaElementsPreview(props) {
      return <div className="coam-info-container">
        <hr />
        <div className="coam-info-head">{props.head || "More Elements with PRO"}</div>
        <div className="coam-info-text">{props.text || len + " extra elements. More coming every month."}</div>
        <div className="coam-info-button-div"><a href="/subscription-plan/" target="_blank"><span className="coam-info-button">Unlock all elements</span></a></div>
      </div>
    }

    return (
      <div className="coaChargesContainer" style={{ height: "73vh", display: "flex", flexDirection: "column", overflowY: "auto" }}>
        <CoaAdsense></CoaAdsense>
        <div><input className="coaSearchInput" type="text" placeholder="Search Exterior" onChange={event => { setSearchTerm(event.target.value) }} /></div>
        <Tabs
          animate={true}
          key={"vertical"}
          vertical={false}
        >
          <Tab id="ew" title="Mantles" panel={
            <div>
              <ImagesGrid
                images={mtlImages}
                getPreview={(image) => {
                  const modifiedUrl = `/wp-content/coamakerbasic/prev/${image.preview}`;
                  return modifiedUrl;
                }}
                onSelect={async (image, pos) => {
                  let url = image.url;
                  if (url.search(".svg") === -1) {
                    url = `/wp-content/coamakerbasic/img/${url}.svg`
                  }
                  image.url = url;
                  let { width, height } = await getImageSize(image.url);
                  width = width / 1.5;
                  height = height / 1.5;
                  store.activePage.addElement({
                    type: "svg",
                    src: image.url,
                    width,
                    height,
                    x: (pos?.x - width / 1.5) || (store.width / 2) - (width / 2),
                    y: (pos?.y - height / 1.5) || (store.height / 2) - (height / 2),
                    name: image.name,
                    keepRatio: false
                  });
                }}
                rowsNumber={3}
                isLoading={false}
                loadMore={false}
              />
              <div className={"coa-pro-preview"}>
                <CoaElementsPreview></CoaElementsPreview>
                <ImagesGrid
                  images={mtlPreview}
                  getPreview={(image) => {
                    const modifiedUrl = `/wp-content/coamakerbasic/prev/${image.preview}`;
                    return modifiedUrl;
                  }}
                  onSelect={async (image, pos) => {
                  }}
                  rowsNumber={3}
                  isLoading={!images.length}
                  loadMore={false}
                />
              </div>
            </div>
          } />
          <Tab id="dv" title="Crowns" panel={
            <div><ImagesGrid
              images={corImages}
              getPreview={(image) => {
                const modifiedUrl = `/wp-content/coamakerbasic/prev/${image.preview}`;
                return modifiedUrl;
              }}
              onSelect={async (image, pos) => {
                let url = image.url;
                if (url.search(".svg") === -1) {
                  url = `/wp-content/coamakerbasic/img/${url}.svg`
                }
                image.url = url;
                let { width, height } = await getImageSize(image.url);
                width = width / 1.5;
                height = height / 1.5;
                store.activePage.addElement({
                  type: "svg",
                  src: image.url,
                  width,
                  height,
                  x: (pos?.x - width / 1.5) || (store.width / 2) - (width / 2),
                  y: (pos?.y - height / 1.5) || (store.height / 2) - (height / 2),
                  name: image.name,
                  keepRatio: false
                });
              }}
              rowsNumber={3}
              isLoading={false}
              loadMore={false}
            />
              <div className={"coa-pro-preview"}>
                <CoaElementsPreview></CoaElementsPreview>
                <ImagesGrid
                  images={corPreview}
                  getPreview={(image) => {
                    const modifiedUrl = `/wp-content/coamakerbasic/prev/${image.preview}`;
                    return modifiedUrl;
                  }}
                  onSelect={async (image, pos) => {
                  }}
                  rowsNumber={3}
                  isLoading={!images.length}
                  loadMore={false}
                />
              </div>
            </div>
          } />
          <Tab id="pk" title="Supporters" panel={
            <div><ImagesGrid
              images={supImages}
              getPreview={(image) => {
                const modifiedUrl = `/wp-content/coamakerbasic/prev/${image.preview}`;
                return modifiedUrl;
              }}
              onSelect={async (image, pos) => {
                let url = image.url;
                if (url.search(".svg") === -1) {
                  url = `/wp-content/coamakerbasic/img/${url}.svg`
                }
                image.url = url;
                let { width, height } = await getImageSize(image.url);
                width = width / 1.5;
                height = height / 1.5;
                store.activePage.addElement({
                  type: "svg",
                  src: image.url,
                  width,
                  height,
                  x: (pos?.x - width / 1.5) || (store.width / 2) - (width / 2),
                  y: (pos?.y - height / 1.5) || (store.height / 2) - (height / 2),
                  name: image.name,
                  keepRatio: false
                });
              }}
              rowsNumber={3}
              isLoading={false}
              loadMore={false}
              getCredit={(image) => image.name}
            />
              <div className={"coa-pro-preview"}>
                <CoaElementsPreview></CoaElementsPreview>
                <ImagesGrid
                  images={supPreview}
                  getPreview={(image) => {
                    const modifiedUrl = `/wp-content/coamakerbasic/prev/${image.preview}`;
                    return modifiedUrl;
                  }}
                  onSelect={async (image, pos) => {
                  }}
                  rowsNumber={3}
                  isLoading={!images.length}
                  loadMore={false}
                  getCredit={(image) => image.name}
                />
              </div>
            </div>
          } />
          <Tab id="pq" title="Other" panel={
            <div><ImagesGrid
              images={othImages}
              getPreview={(image) => {
                const modifiedUrl = `/wp-content/coamakerbasic/prev/${image.preview}`;
                return modifiedUrl;
              }}
              onSelect={async (image, pos) => {
                let url = image.url;
                if (url.search(".svg") === -1) {
                  url = `/wp-content/coamakerbasic/img/${url}.svg`
                }
                image.url = url;
                let { width, height } = await getImageSize(image.url);
                width = width / 1.5;
                height = height / 1.5;
                store.activePage.addElement({
                  type: "svg",
                  src: image.url,
                  width,
                  height,
                  x: (pos?.x - width / 1.5) || (store.width / 2) - (width / 2),
                  y: (pos?.y - height / 1.5) || (store.height / 2) - (height / 2),
                  name: image.name,
                  keepRatio: false
                });
              }}
              rowsNumber={3}
              isLoading={false}
              loadMore={false}
            />
              <div className={"coa-pro-preview"}>
                <CoaElementsPreview></CoaElementsPreview>
                <ImagesGrid
                  images={othPreview}
                  getPreview={(image) => {
                    const modifiedUrl = `/wp-content/coamakerbasic/prev/${image.preview}`;
                    return modifiedUrl;
                  }}
                  onSelect={async (image, pos) => {
                  }}
                  rowsNumber={3}
                  isLoading={!images.length}
                  loadMore={false}
                />
              </div>
            </div>
          } />
        </Tabs>
      </div>

    );
  }),
};

const ShieldSection = {
  name: 'shields',
  Tab: (props) => (
    <SectionTab name="Shields" {...props} >
      <BiShieldQuarter />
    </SectionTab>
  ),
  // we need observer to update component automatically on any store changes
  Panel: observer(({ store }) => {
    const [images, setImages] = React.useState([]);

    async function loadImages() {
      const time = parseInt((new Date()).getTime() / 100000);
      const shieldsUrl = "/wp-content/coamakerbasic/coa/0_coam.json?=ver";
      const shieldFetch = shieldsUrl + time;
      fetch(shieldFetch)
        .then(function (resp) {
          return resp.json();
        })
        .then(function (data) {
          setImages(data);
        });
      //setImages(data.url);
      await new Promise((resolve) => setTimeout(resolve, 3000));
    }

    React.useEffect(() => {
      loadImages();
    }, []);

    const [coaSearchTerm, setSearchTerm] = useState('');

    var shieldImages = []
    for (var c = 0; c < images.length; c++) {
      let image = images[c];
      if (coaSearchTerm === "") {
        if ((image["pro"] === false) && (image["sec"] === "shd")) {
          shieldImages.push(images[c]);
        }
      }
      else if (coaSearchTerm !== "") {
        if (
          (image["pro"] === false) &&
          (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
            && ((image["sec"] === "shd"))
          )) {
          shieldImages.push(images[c]);
        }
      }
    }

    var lozImages = []
    for (var k = 0; k < images.length; k++) {
      let image = images[k];
      if (coaSearchTerm === "") {
        if ((image["pro"] === false) && (image["sec"] === "loz")) {
          lozImages.push(images[k]);
        }
      }
      else if (coaSearchTerm !== "") {
        if (
          (image["pro"] === false) &&
          (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
            && ((image["sec"] === "loz"))
          )) {
          lozImages.push(images[k]);
        }
      }
    }


    var bannImages = []
    for (var d = 0; d < images.length; d++) {
      let image = images[d];
      if (coaSearchTerm === "") {
        if ((image["pro"] === false) && (image["sec"] === "ban")) {
          bannImages.push(images[d]);
        }
      }
      else if (coaSearchTerm !== "") {
        if (
          (image["pro"] === false) &&
          (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
            && ((image["sec"] === "ban"))
          )) {
          bannImages.push(images[d]);
        }
      }
    }

    var roundImages = []
    for (var e = 0; e < images.length; e++) {
      let image = images[e];
      if (coaSearchTerm === "") {
        if ((image["pro"] === false) && (image["sec"] === "rnd")) {
          roundImages.push(images[e]);
        }
      }
      else if (coaSearchTerm !== "") {
        if (
          (image["pro"] === false) &&
          (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
            && ((image["sec"] === "rnd"))
          )) {
          roundImages.push(images[e]);
        }
      }
    }


    var previewShields = []
    for (var p = 0; p < images.length; p++) {
      let image = images[p];
      if (coaSearchTerm === "") {
        if ((image["pro"] === true) && (image["sec"] === "shd")) {
          previewShields.push(images[p]);
        }
      }
      else if (coaSearchTerm !== "") {
        if (
          (image["pro"] === true) &&
          (image["srch"].toLowerCase().includes(coaSearchTerm.toLowerCase())
            && ((image["sec"] === "shd"))
          )) {
          previewShields.push(images[p]);
        }
      }
    }

    var previewLoz = []
    for (var m = 0; m < images.length; m++) {
      let image = images[m];
      if ((image["pro"] === true) && (image["sec"] === "loz")) {
        previewLoz.push(images[m]);
      }
    }

    var previewBann = []
    for (var i = 0; i < images.length; i++) {
      let image = images[i];
      if ((image["pro"] === true) && (image["sec"] === "ban")) {
        previewBann.push(images[i]);
      }
    }

    var previewRounds = []
    for (var f = 0; f < images.length; f++) {
      let image = images[f];
      if ((image["pro"] === true) && (image["sec"] === "rnd")) {
        previewRounds.push(images[f]);
      }
    }

    var previewImages = []
    for (var i = 0; i < images.length; i++) {
      let image = images[i];
      if (image["pro"] === true) {
        previewImages.push(images[i]);
      }
    }

    var len = previewImages.length

    function CoaElementsPreview(props) {
      return <div className="coam-info-container">
        <hr />
        <div className="coam-info-head">{props.head || "More Elements with PRO"}</div>
        <div className="coam-info-text">{props.text || len + " extra elements. More coming every month."}</div>
        <div className="coam-info-button-div"><a href="/subscription-plan/" target="_blank"><span className="coam-info-button">Unlock all elements</span></a></div>
      </div>
    }

    return (
      <div style={{ height: "100%", display: "flex", flexDirection: "column", overflowY: "auto" }}>
        <CoaAdsense></CoaAdsense>
        <div><input className="coaSearchInput" type="text" placeholder="Search Shields" onChange={event => { setSearchTerm(event.target.value) }} /></div>
        <Tabs
          animate={true}
          key={"vertical"}
          vertical={false}
        >
          <Tab id="fsi" title="Shields" panel={
            <div><ImagesGrid
              images={shieldImages}
              getPreview={(image) => {
                const modifiedUrl = `/wp-content/coamakerbasic/prev/${image.preview}`;
                return modifiedUrl;
              }}
              onSelect={async (image, pos) => {
                let url = image.url;
                if (url.search(".svg") === -1) {
                  url = `/wp-content/coamakerbasic/img/${url}.svg`
                }
                image.url = url;
                let { width, height } = await getImageSize(image.url);
                width = width / 1.5;
                height = height / 1.5;
                store.activePage.addElement({
                  type: "svg",
                  src: image.url,
                  width,
                  height,
                  x: (pos?.x - width / 1.5) || (store.width / 2) - (width / 2),
                  y: (pos?.y - height / 1.5) || (store.height / 2) - (height / 2),
                  name: image.name,
                  keepRatio: false
                });
              }}
              rowsNumber={4}
              isLoading={false}
              loadMore={false}
              getCredit={(image) => image.name}
            />
              <div className={"coa-pro-preview"}>
                <CoaElementsPreview text="Use the full potential of our family crest maker, sigil maker, and heraldry studio. Make your coat of arms with hundreds of elements. Use our coat of arms templates."></CoaElementsPreview>
                <ImagesGrid
                  images={previewShields}
                  getPreview={(image) => {
                    const modifiedUrl = `/wp-content/coamakerbasic/prev/${image.preview}`;
                    return modifiedUrl;
                  }}
                  onSelect={async (image, pos) => {
                  }}
                  rowsNumber={4}
                  isLoading={!images.length}
                  loadMore={false}
                  getCredit={(image) => image.name}
                />
              </div>
            </div>
          } />
          <Tab id="flt" title="Lozenges" panel={
            <div><ImagesGrid
              images={lozImages}
              getPreview={(image) => {
                const modifiedUrl = `/wp-content/coamakerbasic/prev/${image.preview}`;
                return modifiedUrl;
              }}
              onSelect={async (image, pos) => {
                let url = image.url;
                if (url.search(".svg") === -1) {
                  url = `/wp-content/coamakerbasic/img/${url}.svg`
                }
                image.url = url;
                let { width, height } = await getImageSize(image.url);
                width = width / 1.5;
                height = height / 1.5;
                store.activePage.addElement({
                  type: "svg",
                  src: image.url,
                  width,
                  height,
                  x: (pos?.x - width / 1.5) || (store.width / 2) - (width / 2),
                  y: (pos?.y - height / 1.5) || (store.height / 2) - (height / 2),
                  name: image.name,
                  keepRatio: false
                });
              }}
              rowsNumber={4}
              isLoading={false}
              loadMore={false}
            />
              <div className={"coa-pro-preview"}>
                <CoaElementsPreview text="Create lozenge and diamond shaped coat of arms for classical designs for women in heraldry or emblems and sigils."></CoaElementsPreview>
                <ImagesGrid
                  images={previewLoz}
                  getPreview={(image) => {
                    const modifiedUrl = `/wp-content/coamakerbasic/prev/${image.preview}`;
                    return modifiedUrl;
                  }}
                  onSelect={async (image, pos) => {
                  }}
                  rowsNumber={4}
                  isLoading={!images.length}
                  loadMore={false}
                />
              </div>
            </div>
          } />
          <Tab id="frd" title="Rounds" panel={
            <div><ImagesGrid
              images={roundImages}
              getPreview={(image) => {
                const modifiedUrl = `/wp-content/coamakerbasic/prev/${image.preview}`;
                return modifiedUrl;
              }}
              onSelect={async (image, pos) => {
                let url = image.url;
                if (url.search(".svg") === -1) {
                  url = `/wp-content/coamakerbasic/img/${url}.svg`
                }
                image.url = url;
                let { width, height } = await getImageSize(image.url);
                width = width / 1.5;
                height = height / 1.5;
                store.activePage.addElement({
                  type: "svg",
                  src: image.url,
                  width,
                  height,
                  x: (pos?.x - width / 1.5) || (store.width / 2) - (width / 2),
                  y: (pos?.y - height / 1.5) || (store.height / 2) - (height / 2),
                  name: image.name,
                  keepRatio: false
                });
              }}
              rowsNumber={3}
              isLoading={false}
              loadMore={false}
            />
              <div className={"coa-pro-preview"}>
                <CoaElementsPreview head="More Round Templates with PRO" text="Emblem, Coin, and Sigil Maker: Create coins, Japanese mon emblems, Viking shields, and artwork for worlbuilding projects."></CoaElementsPreview>
                <ImagesGrid
                  images={previewRounds}
                  getPreview={(image) => {
                    const modifiedUrl = `/wp-content/coamakerbasic/prev/${image.preview}`;
                    return modifiedUrl;
                  }}
                  onSelect={async (image, pos) => {
                  }}
                  rowsNumber={3}
                  isLoading={!images.length}
                  loadMore={false}
                />
              </div>
            </div>
          } />
          <Tab id="fbr" title="Flags" panel={
            <div><ImagesGrid
              images={bannImages}
              getPreview={(image) => {
                const modifiedUrl = `/wp-content/coamakerbasic/prev/${image.preview}`;
                return modifiedUrl;
              }}
              onSelect={async (image, pos) => {
                let url = image.url;
                if (url.search(".svg") === -1) {
                  url = `/wp-content/coamakerbasic/img/${url}.svg`
                }
                image.url = url;
                let { width, height } = await getImageSize(image.url);
                width = width / 1.5;
                height = height / 1.5;
                store.activePage.addElement({
                  type: "svg",
                  src: image.url,
                  width,
                  height,
                  x: (pos?.x - width / 1.5) || (store.width / 2) - (width / 2),
                  y: (pos?.y - height / 1.5) || (store.height / 2) - (height / 2),
                  name: image.name,
                  keepRatio: false
                });
              }}
              rowsNumber={3}
              isLoading={false}
              loadMore={false}
            />
              <div className={"coa-pro-preview"}>
                <CoaElementsPreview head="More Flags & Banners with PRO" text="Flag Maker: Make your own flag with the flag templates in our generator. Design country and fantasy flags in medieval style with our vexillology and banner creator."></CoaElementsPreview>
                <ImagesGrid
                  images={previewBann}
                  getPreview={(image) => {
                    const modifiedUrl = `/wp-content/coamakerbasic/prev/${image.preview}`;
                    return modifiedUrl;
                  }}
                  onSelect={async (image, pos) => {
                  }}
                  rowsNumber={3}
                  isLoading={!images.length}
                  loadMore={false}
                />
              </div>
            </div>
          } />
        </Tabs>

      </div >
    );
  }),
};


const TemplatesPanel = observer(({ store }) => {

  return (
    <div style={{ height: '100%' }} className="coa-template-container">
      <h4>Templates are a PRO feature</h4>
      <div className="coam-promotion-panel">Use pre-arranged templates to create your complex coat of arms quickly.</div>
      <div className="coam-promotion-panel">Switch colors and elements quickly.</div>
      <div className="coam-info-button-div"><a href="/subscription-plan/" target="_blank"><span className="coam-info-button">Learn more</span></a></div>
      <div><img src="/wp-content/coamakerbasic/templates/Templates_Preview.jpg" width="100%" /></div>
    </div>
  );
});

const TemplatesSection = {
  name: 'custom-templates',
  Tab: (props) => (
    <SectionTab name="Templates" {...props}>
      <FaFileImport />
    </SectionTab>

  ),
  // we need observer to update component automatically on any store changes
  Panel: TemplatesPanel,
};


const ToolPanel = observer(({ store }) => {

  return (
    <div className="coaChargesContainer" style={{ height: "100%", display: "flex", flexDirection: "column", overflowY: "auto" }}>
      <CoaAdsense></CoaAdsense>
      <Tabs
        animate={true}
        key={"vertical"}
        vertical={false}
      >
        <Tab id="fsz" title="Format" panel={
          <div>
            <div>
              {AVAILABLE_SIZES.map(({ width, height, format }, i) => (
                <Button
                  key={i}
                  style={{ width: "100%", marginBottom: "10px", display: "flex", justifyContent: "space-between", alignItems: "center" }}
                  onClick={() => {
                    store.setSize(width, height, true);
                    store.deleteElements(["logo"]);
                    store.activePage.addElement({
                      type: "svg",
                      src: "/wp-content/coamakerbasic/coageneral/coamakerlogo.svg",
                      height: height / 1080 * 100,
                      width: height / 1080 * 201,
                      x: height / 1080 * 25,
                      y: height - height / 1080 * 25 - height / 1080 * 100,
                      name: "CoaMaker Logo",
                      locked: true,
                      selectable: false,
                      alwaysOnTop: true,
                      id: "logo"
                    });
                  }}
                >
                  <span style={{ fontWeight: "bold" }}>{format} </span>
                  <span>{`${width} x ${height}`}</span>
                </Button>
              ))}
            </div>
            <div style={{ marginTop: "25px" }}>
              <h4>More sizes with PRO</h4>
              <div className="coam-promotion-panel">With a PRO account, you can use US letter and European A4 sizes. You can also set custom sizes.</div>
              <div className="coam-info-button-div"><a href="/subscription-plan/" target="_blank"><span className="coam-info-button">Learn more</span></a></div>
            </div>
          </div>
        } />
        <Tab id="fup" title="Upload" panel={
          <div>
            <h4>Uploads are a PRO feature</h4>
            <div className="coam-promotion-panel">Do you want to upload your own elements?</div>
            <div className="coam-promotion-panel">With a PRO account you can add every image file you want to your design.</div>
            <div className="coam-info-button-div"><a href="/subscription-plan/" target="_blank"><span className="coam-info-button">Learn more</span></a></div>
          </div>
        } />
        <Tab id="ftx" title="Text" panel={
          <div>
            <h4>Add Text is a PRO feature</h4>
            <div className="coam-promotion-panel">Add family names, realms names, and mottos above, below, or on your shield.</div>
            <div className="coam-promotion-panel">Use carefully selected fonts or switch to dozens of others.</div>
            <div className="coam-info-button-div"><a href="/subscription-plan/" target="_blank"><span className="coam-info-button">Learn more</span></a></div>
            <div><img src="/wp-content/coamakerbasic/fonts/Text_Preview.jpg" width="100%" /></div>
          </div>
        } />
        <Tab id="ftp" title="Templates" panel={
          <div>
            <h4>Templates are a PRO feature</h4>
            <div className="coam-promotion-panel">Use pre-arranged templates to create your complex coat of arms quickly.</div>
            <div className="coam-promotion-panel">Switch colors and elements quickly.</div>
            <div className="coam-info-button-div"><a href="/subscription-plan/" target="_blank"><span className="coam-info-button">Learn more</span></a></div>
            <div><img src="/wp-content/coamakerbasic/templates/Templates_Preview.jpg" width="100%" /></div>
          </div>
        } />
      </Tabs>
    </div>
  );
});

const ToolSection = {
  name: 'tools',
  Tab: (props) => (
    <SectionTab name="Tools" {...props}>
      <Icon size={20} icon="build" />
    </SectionTab>

  ),
  // we need observer to update component automatically on any store changes
  Panel: ToolPanel,
};

const dntTutorials = [
  { title: "How to Adjust Colors", videoId: "pTN3BYDpv6A" },
  { title: "How to Use Layers", videoId: "DAlWDPMvEFk" },
  { title: "How to Set the Canvas Size", videoId: "-UATB0j8WKc" },
  { title: "How to Save Designs (PRO)", videoId: "L_UPW_Fd7to" }
];

const HelpPanel = observer(({ store }) => {

  return (
    <div className="coaChargesContainer" style={{ height: "73vh", display: "flex", flexDirection: "column", overflowY: "auto" }}>
      {/* Map through videos array to render a TutorialModal for each video */}
      {dntTutorials.map((video, index) => (
        <TutorialModal key={index} title={video.title} videoId={video.videoId} />
      ))}
      <div className="coam-promotion-panel">As a PRO user, you can save your designs and export them in higher quality with transparent background.</div>
      <div className="coam-info-button-div"><a href="/subscription-plan/" target="_blank"><span className="coam-info-button">Learn more</span></a></div>
    </div>
  );
});

const HelpSection = {
  name: 'prints',
  Tab: (props) => (
    <SectionTab name="Tutorial" {...props}>
      <Icon size={20} icon="learning" />
    </SectionTab>

  ),
  // we need observer to update component automatically on any store changes
  Panel: HelpPanel,
};

const SavePanel = observer(({ store }) => {

  return (
    <div style={{ height: '100%' }}>
      <h4>Saving is a PRO feature</h4>
      <TutorialModal key="1" title="How to Save Your Designs" videoId="L_UPW_Fd7to" />
      <div className="coam-promotion-panel">With a PRO account, you can save your designs online and continue editing it later.</div>
      <div className="coam-info-button-div"><a href="/subscription-plan/" target="_blank"><span className="coam-info-button">Learn more</span></a></div>
    </div>
  );
});

const SaveSection = {
  name: 'custom-save',
  Tab: (props) => (
    <SectionTab name="Save" {...props}>
      <Icon size={20} icon="floppy-disk" />
    </SectionTab>

  ),
  // we need observer to update component automatically on any store changes
  Panel: SavePanel,
};

const FlagPanel = observer(({ store }) => {

  return (
    <div className="Templates-Panel-32" style={{ height: "86%", display: "flex", flexDirection: "column", overflowY: "auto", overflowX: "hidden" }}>
      <h4>Create Flags</h4>
      <div className="coam-promotion-panel">Use hundreds of symbols and templates in Flag Creator.</div>
      <div className="coam-promotion-panel">Make custom flags and emblems.</div>
      <div className="coam-info-button-div"><a href="https://flag-creator.com" target="_blank"><span className="coam-info-button">Try it now</span></a></div>
      <div style={{ textAlign: "center", paddingBottom: "20px" }}><a href="https://flag-creator.com" target="_blank"><img src="/wp-content/coamakerbasic/coageneral/eagleflag.png" width="80%" border="1px solid" /></a></div>
      <div style={{ textAlign: "center", paddingBottom: "20px" }}><a href="https://flag-creator.com" target="_blank"><img src="/wp-content/coamakerbasic/coageneral/usflag.png" width="80%" border="1px solid" /></a></div>
      <div style={{ textAlign: "center" }}><a href="https://flag-creator.com" target="_blank"><img src="/wp-content/coamakerbasic/coageneral/crownflag.png" width="80%" border="1px solid" /></a></div>
    </div>
  );
});

const FlagSection = {
  name: 'custom-uploads2',
  Tab: (props) => (
    <SectionTab name="Flags" {...props}>
      <img src="/wp-content/coamakerbasic/coageneral/flagshield.svg" className="coa-red" width="25px" />
    </SectionTab>

  ),
  // we need observer to update component automatically on any store changes
  Panel: FlagPanel,
};

const AiSection = {
  name: 'ai',
  Tab: (props) => (
    <SectionTab name="AI" {...props}>
      <FaMagic />
    </SectionTab>
  ),

  Panel: observer(({ store }) => {
    const [images, setImages] = React.useState([]);
    const [secFlagImages, setSecFlagImages] = React.useState([]);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);



    async function loadImages() {
      const time = parseInt((new Date()).getTime() / 100000);
      const animalUrl = "/wp-content/coamakerbasic/coa/0_coam.json?=ver";
      const animalFetch = animalUrl + time;

      try {
        const resp = await fetch(animalFetch);
        const data = await resp.json();

        // Filter the JSON entries based on the 'sec' property
        const filteredData = data.filter(entry => {
          const sec = entry.sec;
          const pro = entry.pro;
          return (sec === 'pla' || sec === 'ina' || sec === 'hum' || sec === 'pla') && !pro;
        });


        // Set the images state with the filtered data
        setImages(filteredData);

        // Filter again to get only 'sec' flag images
        let secFlagFilteredData;
        const arrayFlags = ['coashields/345_Shield_undivided', 'coashields/896_slim', 'coashields/745_sq', 'coashields/345_Shield_undivided', 'coashields/896_slim', 'coashields/745_sq', 'coashields/345_Shield_undivided', 'coashields/896_slim', 'coashields/745_sq', 'coashields/923_party_per_fess', 'coashields/345_Shield_undivided', 'coashields/234_party_per_pale', 'coashields/838_party_per_bend', 'coashields/896_slim', 'coashields/745_sqppale', 'coashields/871_sqpbend', 'coashields/523_sqpfess',];
        // 50% chance to use the arrayFlags in secFlagFilteredData
        secFlagFilteredData = arrayFlags.map(url => ({ url, sec: 'shd' }));


        // Set the sec flag images state
        setSecFlagImages(secFlagFilteredData);
      } catch (error) {
        console.error("Error loading images:", error);
      }

      // Wait for 3 seconds before resolving
      await new Promise((resolve) => setTimeout(resolve, 3000));
    }

    React.useEffect(() => {
      loadImages();
    }, []);

    //console.log(secFlagImages);

    // Function to download SVG file and get its content as string
    async function urlToString(url) {
      const req = await fetch(url, { mode: 'cors' });
      const svgString = await req.text();
      return svgString;
    }

    // Function to parse SVG string into DOM
    function parseSVG(svgString) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(svgString, 'image/svg+xml');
      return doc;
    }

    // Regular expressions for color attributes
    const fillColorRegex = /fill="(#[0-9A-Fa-f]{3,6}|rgb\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*\)|\b(black|white|red|green|blue|yellow|orange|purple|pink)\b)"/g;
    const strokeColorRegex = /stroke="(#[0-9A-Fa-f]{3,6}|rgb\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*\)|\b(black|white|red|green|blue|yellow|orange|purple|pink)\b)"/g;
    const styleColorRegex = /style="(.*?)"/g;



    // Function to parse SVG string into DOM
    function parseSVG(svgString) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(svgString, 'image/svg+xml');
      return doc;
    }


    const handleAddRandomSymbol = async () => {
      try {
        setIsButtonDisabled(true);
        if (images.length === 0 || secFlagImages.length === 0) {
          return;
        }

        let ids = store.pages
          .map((page) => page.children.map((child) => child.id))
          .flat();
        store.deleteElements(ids);
        const logoPresent = ids.includes('logo') ? '1' : '0';
        if (logoPresent !== '0') {
          let logoStoreWidth = store.width;
          let logoStoreHeight = store.height;
          store.deleteElements(["logo"]);
          store.activePage.addElement({
            type: "svg",
            src: "/wp-content/coamakerbasic/coageneral/coamakerlogo.svg",
            height: logoStoreHeight / 1080 * 100,
            width: logoStoreHeight / 1080 * 201,
            x: logoStoreWidth / 1080 * 25,
            y: logoStoreHeight - logoStoreHeight / 1080 * 25 - logoStoreHeight / 1080 * 100,
            name: "CoaMaker Logo",
            locked: true,
            selectable: true,
            alwaysOnTop: true,
            id: "logo"
          });
        }

        // For the symbol
        const randomIndex = Math.floor(Math.random() * images.length);
        const randomSymbol = images[randomIndex];
        let url = randomSymbol.url;
        if (url.search(".svg") === -1) {
          url = `/wp-content/coamakerbasic/img/${url}.svg`;
        }
        randomSymbol.url = url;

        // Fetch and parse SVG for the old image
        const svgString = await urlToString(randomSymbol.url);

        // For the flag
        const randomIndexSecFlag = Math.floor(Math.random() * secFlagImages.length);
        const randomFlag = secFlagImages[randomIndexSecFlag];
        let urlSecFlag = randomFlag.url;
        if (urlSecFlag.search(".svg") === -1) {
          urlSecFlag = `/wp-content/coamakerbasic/${urlSecFlag}.svg`;
        }
        randomFlag.url = urlSecFlag;

        // Fetch and parse SVG for the new image
        const svgStringSecFlag = await urlToString(randomFlag.url);
        //console.log(svgStringSecFlag);

        // Create a map to store color replacements
        const symbolColorReplacementMap = new Map();
        const flagColorReplacementMap = new Map();

        function shuffleArray(array) {
          for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
          }
        }

        const coaMetals = ['#F7C702', '#F2F2F2'];
        shuffleArray(coaMetals);

        const coaColors = ['#013B90', '#BB212C', '#1B1B1B', '#1D5E23', '#742974'];
        shuffleArray(coaColors);

        const coaChargeMetal = Math.random() < 0.5;

        const availableChargeColors = (coaChargeMetal ? coaMetals : coaColors);
        const randomColorIndex = Math.floor(Math.random() * availableChargeColors.length);
        const newChargeColor = availableChargeColors[randomColorIndex];

        // Replace fill attributes with new colors
        const modifiedSvgStringFill = svgString.replace(fillColorRegex, (match) => {
          // Check if this color has been replaced before
          if (symbolColorReplacementMap.has(match)) {
            return symbolColorReplacementMap.get(match);
          }
          // Store the mapping of old color to new color
          symbolColorReplacementMap.set(match, newChargeColor);
          //console.log(`Replacing fill attribute with ${newColor}`);
          return `fill="${newChargeColor}"`;
        });

        // Replace stroke attributes with new colors
        const modifiedSvgStringStroke = modifiedSvgStringFill.replace(strokeColorRegex, (match) => {
          symbolColorReplacementMap.set(match, newChargeColor);
          //console.log(`Replacing stroke attribute with ${newColor}`);
          return `stroke="${newChargeColor}"`;
        });

        // Replace style attributes with new fill color
        const modifiedSvgStringStyle = modifiedSvgStringStroke.replace(styleColorRegex, (match) => {
          // Extract the existing style content
          const existingStyle = match.match(/style="(.*?)"/)[1];
          // Replace only the fill color within the style
          const newStyle = existingStyle.replace(/fill:(?!#?(000000|000|F2F2F2|B5B5B5)\b)(#[0-9A-Fa-f]{3,6}|rgb\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*\)|\b(white|red|green|blue|yellow|orange|purple|pink)\b)/g, (fillMatch) => {
            symbolColorReplacementMap.set(fillMatch, newChargeColor);
            // Remove the used color from colorArray
            //console.log(`Replacing fill color within style with ${newColor}`);
            return `fill:${newChargeColor}`;
          });
          // Replace the entire style attribute with the modified style content
          return `style="${newStyle}"`;
        });

        // Fetch and parse the modified SVG
        const modifiedDoc = parseSVG(modifiedSvgStringStyle);

        // Serialize SVG back into a string
        const serializer = new XMLSerializer();
        const newSvgString = serializer.serializeToString(modifiedDoc);

        // Replace fill attributes with new colors for randomFlag
        const modifiedSvgStringFillFlag = svgStringSecFlag.replace(fillColorRegex, (match) => {
          // Check if this color has been replaced before
          //console.log("colorArray");
          //console.log(colorArray);
          if (flagColorReplacementMap.has(match)) {
            return flagColorReplacementMap.get(match);
          }
          const availableColors = (coaChargeMetal ? coaColors : coaMetals).filter(color => !flagColorReplacementMap.has(color));
          if (availableColors.length === 0) {
            // No available colors left, return the original color
            return match;
          }
          const randomColorIndex = Math.floor(Math.random() * availableColors.length);
          const newColor = availableColors[randomColorIndex];
          // Store the mapping of old color to new color
          flagColorReplacementMap.set(match, newColor);
          // Remove the used color from colorArray
          const indexToRemove = (coaChargeMetal ? coaColors : coaMetals).indexOf(newColor);
          if (indexToRemove !== -1) {
            (coaChargeMetal ? coaColors : coaMetals).splice(indexToRemove, 1);
          }
          //console.log(`Replacing fill attribute with ${newColor}`);
          return `fill="${newColor}"`;
        });

        // Replace stroke attributes with new colors for randomFlag
        const modifiedSvgStringStrokeFlag = modifiedSvgStringFillFlag.replace(strokeColorRegex, (match) => {
          // Check if this color has been replaced before
          if (flagColorReplacementMap.has(match)) {
            return flagColorReplacementMap.get(match);
          }
          const availableColors = (coaChargeMetal ? coaColors : coaMetals).filter(color => !flagColorReplacementMap.has(color));
          if (availableColors.length === 0) {
            // No available colors left, return the original color
            return match;
          }
          const randomColorIndex = Math.floor(Math.random() * availableColors.length);
          const newColor = availableColors[randomColorIndex];
          // Store the mapping of old color to new color
          flagColorReplacementMap.set(match, newColor);
          // Remove the used color from colorArray
          const indexToRemove = (coaChargeMetal ? coaColors : coaMetals).indexOf(newColor);
          if (indexToRemove !== -1) {
            (coaChargeMetal ? coaColors : coaMetals).splice(indexToRemove, 1);
          }
          //log(`Replacing stroke attribute with ${newColor}`);
          return `stroke="${newColor}"`;
        });

        // Replace style attributes with new fill color for randomFlag
        const modifiedSvgStringStyleFlag = modifiedSvgStringStrokeFlag.replace(styleColorRegex, (match) => {
          // Extract the existing style content
          const existingStyle = match.match(/style="(.*?)"/)[1];
          // Replace only the fill color within the style
          const newStyle = existingStyle.replace(/fill:(?!#?(000000|000|F2F2F2|B5B5B5)\b)(#[0-9A-Fa-f]{3,6}|rgb\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*\)|\b(white|red|green|blue|yellow|orange|purple|pink)\b)/g, (fillMatch) => {
            // Check if this color has been replaced before
            if (flagColorReplacementMap.has(fillMatch)) {
              return `fill:${flagColorReplacementMap.get(fillMatch)}`;
            }
            const availableColors = (coaChargeMetal ? coaColors : coaMetals).filter(color => !flagColorReplacementMap.has(color));
            if (availableColors.length === 0) {
              // No available colors left, return the original color
              return fillMatch;
            }
            const randomColorIndex = Math.floor(Math.random() * availableColors.length);
            const newColor = availableColors[randomColorIndex];
            // Store the mapping of old color to new color
            flagColorReplacementMap.set(fillMatch, newColor);
            // Remove the used color from colorArray
            const indexToRemove = (coaChargeMetal ? coaColors : coaMetals).indexOf(newColor);
            if (indexToRemove !== -1) {
              (coaChargeMetal ? coaColors : coaMetals).splice(indexToRemove, 1);
            }
            //console.log(`Replacing fill color within style with ${newColor}`);
            return `fill:${newColor}`;
          });
          // Replace the entire style attribute with the modified style content
          return `style="${newStyle}"`;
        });

        // Fetch and parse the modified SVG for randomFlag
        const modifiedDocFlag = parseSVG(modifiedSvgStringStyleFlag);
        // Serialize SVG back into a string as SVG
        const flagSerializer = new XMLSerializer();
        let newFlagSvgString = flagSerializer.serializeToString(modifiedDocFlag, 'image/svg+xml');


        const isNotSVG = newFlagSvgString.startsWith('<!DOCTYPE html>') || newFlagSvgString.startsWith('<html>');
        // Remove unnecessary whitespace and newlines
        newFlagSvgString = newFlagSvgString.replace(/\n/g, "").replace(/\s{2,}/g, " ");

        // Check if the newFlagSvgString is not an HTML document
        //console.log(randomFlag);




        if (isNotSVG) {
          //console.error('Serialized document is not a valid SVG. Retrying...');
          //console.log(modifiedDocFlag);
          //console.log(newFlagSvgString);
          //console.log(randomFlag);
          //handleAddRandomSymbol();
        } else {
          setIsButtonDisabled(false);
        }

        loadImages();


        let { width: originalFlagWidth, height: originalFlagHeight } = await getImageSize('data:image/svg+xml;utf8,' + encodeURIComponent(newFlagSvgString));

        let flagWidth;
        let flagHeight;

        if (originalFlagWidth < originalFlagHeight) {
          // If originalFlagWidth is smaller than originalFlagHeight
          flagWidth = store.height * 0.85;
          flagHeight = (flagWidth * originalFlagHeight) / originalFlagWidth;
        } else {
          // If originalFlagWidth is larger or equal to originalFlagHeight
          flagHeight = store.height * 0.85;
          flagWidth = (flagHeight * originalFlagWidth) / originalFlagHeight;
        }

        // Ensure that neither flagWidth nor flagHeight exceed store.width * 0.85 or store.height * 0.85 respectively
        const maxWidth = store.width * 0.85;
        const maxHeight = store.height * 0.85;

        if (flagWidth > maxWidth || flagHeight > maxHeight) {
          const scale = Math.min(maxWidth / flagWidth, maxHeight / flagHeight);
          flagWidth *= scale;
          flagHeight *= scale;
        }

        // Calculate the center of the store
        let centerX = store.width / 2;
        let centerY = store.height / 2;

        // Adjust the flag's position to center it
        let x = centerX - (flagWidth / 2);
        let y = centerY - (flagHeight / 2.1);

        store.activePage.addElement({
          type: "svg",
          src: 'data:image/svg+xml;utf8,' + encodeURIComponent(newFlagSvgString),
          width: flagWidth,
          height: flagHeight,
          keepRatio: true,
          x,
          y
        });


        let { width, height } = await getImageSize('data:image/svg+xml;utf8,' + encodeURIComponent(newSvgString));

        // Check if 'randomFlag' contains 'slim'
        let shieldSize = randomFlag.url.includes("slim") ? 0.65 : 0.75;

        // Set widthScale and heightScale based on the condition
        let widthScale = (flagWidth * shieldSize) / width;
        let heightScale = (flagHeight * shieldSize) / height;

        // Choose the smaller scale to maintain aspect ratio and ensure it doesn't exceed the flag size
        let scale = Math.min(widthScale, heightScale);

        width *= scale;
        height *= scale;

        let chargeYPosition = randomFlag.url.includes("slim") ? 1.7 : 1.9;

        // Calculate the center of the store
        let centerCX = store.width / 2 - (width / 2);
        let centerCY = store.height / 2 - (height / chargeYPosition);

        store.activePage.addElement({
          type: "svg",
          src: 'data:image/svg+xml;utf8,' + encodeURIComponent(newSvgString),
          width,
          height,
          keepRatio: true,
          x: centerCX,
          y: centerCY
        });

      } catch (error) {
        console.error("An error occurred: ", error);
        // Handle any errors here
      } finally {
        setIsButtonDisabled(false);
      }

    };

    return (
      <div className="Templates-Panel-32" style={{ height: "90%", display: "flex", flexDirection: "column", overflowY: "auto", overflowX: "hidden" }}>
        <CoaAdsense></CoaAdsense>
        <div style={{ marginTop: "20px" }}><b>Get Inspired by Our Bot</b></div>
        <div style={{ marginBottom: "20px" }}>Click on the button to generate random coats of arms. Edit the designs until they fit your needs.</div>
        <div>
          <Button
            icon="random"
            style={{ width: '100%' }}
            onClick={handleAddRandomSymbol}
            disabled={isButtonDisabled}
          >
            Create a Random Coat of Arms
          </Button>
        </div>
        <div style={{ marginTop: "25px" }}>
          <h4>More Symbols with PRO</h4>
          <div className="coam-promotion-panel">With a PRO account, you can use hundreds of additionals symbols and save your designs.</div>
          <div className="coam-info-button-div"><a href="/subscription-plan/" target="_blank"><span className="coam-info-button">Learn more</span></a></div>
        </div>
      </div >
    );
  }),
};


const sections = [
  AiSection,
  LayersSection,
  ShieldSection,
  AnimalSection,
  TopSection,
  ToolSection,
  SaveSection,
  HelpSection,
  FlagSection
];

const Opacity = () => null;
const SvgFilters = () => null;

export const App = () => {
  const inputRef = React.useRef();

  return (

    <div
      style={{
        display: "flex",
        height: "90vh",
        width: "100%"
      }}
    >



      <PolotnoContainer className="polotno-app-container">

        <SidePanelWrap className="pro-side-panel">
          <NavbarContainer className="bp5-navbar coam-navbar-promo" >
            <NavInner>
              <Navbar.Group align={Alignment.LEFT} className="coam-navbar-promo-left">
                <div className="coam-promotion-top">"I checked out other generators, but this is the most fun to use – mostly because of the well-selected artwork." – Gerit W.
                </div>
              </Navbar.Group>
              <Navbar.Group align={Alignment.RIGHT} className="coam-navbar-promo-right">
                <div className="coam-sub-button-div"><a href="/subscription-plan/" target="_blank"><span className="coam-sub-button">Learn more</span></a></div>
              </Navbar.Group>
            </NavInner>
          </NavbarContainer>
          <SidePanel store={store} sections={sections} defaultSection="shields" />
        </SidePanelWrap>
        <WorkspaceWrap>
          <Toolbar store={store} downloadButtonEnabled={true} components={{
            Opacity, SvgFilters
          }} >
          </Toolbar>

          <Workspace store={store} backgroundColor="rgba(245, 240, 226, 0.9)" pageControlsEnabled={false} />
          <ZoomButtons store={store} />
        </WorkspaceWrap>
      </PolotnoContainer>
    </div>

  );
};



ReactDOM.render(<App />, document.getElementById("root"));

export default App;